import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';
import { Component } from '@angular/core';

@Component({
    selector: 'app-invited-user-link-renderer',
    templateUrl: './invited-user-link-cell-renderer.component.html',
    styleUrls: ['./invited-user-link-cell-renderer.component.scss'],
    standalone: false,
})
export class InvitedUserLinkCellRendererComponent implements ICellRendererAngularComp {
    private params: any;
    public linkCopied: boolean = false;

    constructor() {
        this.linkCopied = false;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }

    copyInviteLink() {
        navigator.clipboard.writeText(this.params.data.inviteLink);
        // Timeout OK
        setTimeout(() => {
            this.linkCopied = true;
        }, 50);
        // Timeout OK
        setTimeout(() => {
            this.linkCopied = false;
        }, 2000);
    }
}
